import getRenderStatus from './get-render-status';

export default {
  getRenderStatus,
};
